// src/pages/LivraisonEchanges.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';

function LivraisonEchanges() {
  const { t } = useTranslation();

  const delivery = [
    { zone: t('delivery.zone1'), delai: '24–48h', prix: '20 DH' },
    { zone: t('delivery.zone2'), delai: '48–72h', prix: '35 DH' },
    { zone: t('delivery.zone3'), delai: '48–72h', prix: '35 DH' },
    { zone: t('delivery.zone4'), delai: '72h–5 j', prix: '45 DH' },
  ];

  const steps = [
    { num: '1', title: t('delivery.step1Title'), text: t('delivery.step1Text') },
    { num: '2', title: t('delivery.step2Title'), text: t('delivery.step2Text') },
    { num: '3', title: t('delivery.step3Title'), text: t('delivery.step3Text') },
  ];

  return (
    <main className="delivery-page">
      <header className="page-hero">
        <div className="page-hero__inner">
          <span className="page-hero__label">{t('delivery.heroLabel')}</span>
          <h1 className="page-hero__title">{t('delivery.heroTitle')}</h1>
          <p className="page-hero__subtitle">{t('delivery.heroSubtitle')}</p>
        </div>
      </header>

      <section className="delivery-content">
        <div className="delivery-block">
          <h2>{t('delivery.zonesTitle')}</h2>
          <table className="delivery-table">
            <thead>
              <tr>
                <th>{t('delivery.thZone')}</th>
                <th>{t('delivery.thDelay')}</th>
                <th>{t('delivery.thPrice')}</th>
              </tr>
            </thead>
            <tbody>
              {delivery.map((row, i) => (
                <tr key={i}>
                  <td>{row.zone}</td>
                  <td>{row.delai}</td>
                  <td><strong>{row.prix}</strong></td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="delivery-note">{t('delivery.freeNote')}</p>
        </div>

        <div className="delivery-block">
          <h2>{t('delivery.paymentTitle')}</h2>
          <div className="delivery-payment">
            <div className="delivery-payment__item">
              <div className="delivery-payment__icon">💵</div>
              <h3>{t('delivery.payCashTitle')}</h3>
              <p>{t('delivery.payCashText')}</p>
            </div>
            <div className="delivery-payment__item">
              <div className="delivery-payment__icon">🏦</div>
              <h3>{t('delivery.payBankTitle')}</h3>
              <p>{t('delivery.payBankText')}</p>
            </div>
          </div>
        </div>

        <div className="delivery-block">
          <h2>{t('delivery.exchangeTitle')}</h2>
          <div className="delivery-steps">
            {steps.map((step, i) => (
              <div key={i} className="delivery-step">
                <div className="delivery-step__num">{step.num}</div>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </div>
            ))}
          </div>
          <p className="delivery-note">{t('delivery.warningNote')}</p>
        </div>

        <div className="delivery-cta">
          <h3>{t('delivery.ctaTitle')}</h3>
          <p>{t('delivery.ctaText')}</p>
          <a href="https://wa.me/212669428878" target="_blank" rel="noreferrer" className="btn btn-primary">
            {t('delivery.ctaButton')}
          </a>
        </div>
      </section>
    </main>
  );
}

export default LivraisonEchanges;